<template>
	<form class="container-sm mh-100 pt-10" @submit.prevent="submit" autocomplete="off">
		<div class="pb-4 vstack gap-3">
			<div class="text-center">
				<router-link :to="{ name: 'home' }" class="d-inline-block">
					<img src="@/assets/img/logo/complete.png" class="h-rem-10" alt="logo">
				</router-link>
			</div>
			<div class="ls-tight lh-sm text-md text-center px-5 px-md-10">¡Bienvenido de vuelta!</div>
			<div class="card text-bg-white border-0 shadow-none">
				<div class="card-body vstack gap-5">
					<div class="vstack gap-3">
						<CommonFormInputEmail v-model="email" title="Email" placeholder="Ingrese su email" :focus="true" :validation="validation.email" />
						<CommonFormInputPassword v-model="password" title="Contraseña" placeholder="Ingrese su contraseña" :validation="validation.password" />
					</div>
					<div class="text-center" v-if="validationExternal.length > 0">
						<div class="invalid-feedback fw-bold d-block m-0" v-for="(error, index) in validationExternal" v-bind:key="index">{{ error }}</div>
					</div>
					<div class="text-center d-grid gap-3">
						<button type="submit" class="btn btn-md btn-primary" :disabled="submitting">Iniciar sesión</button>
						<button type="button" class="btn btn-md btn-outline-secondary" :disabled="submitting" @click="forgot">Recuperar acceso</button>
					</div>
				</div>
			</div>
		</div>
		<div class="text-center fw-bold pb-10">
			¿No tiene una cuenta?
			<router-link :to="{ name: 'auth.signup' }" class="link-primary ps-2">Registrarse</router-link>
		</div>
	</form>
</template>

<script>
	import { reactive, toRefs } from 'vue';
	import store from '@/store';
	import router from '@/router';
	import useVuelidate from '@vuelidate/core';
	import { required, minLength, maxLength, email } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import composableRedirect from '@/composables/redirect';

	export default {
		setup() {
			const { submitting, validationExternal, catchError } = composableForm();
			const { redirectNext } = composableRedirect();

			const form = reactive({
				email: '',
				password: ''
			});

			const validation = useVuelidate({
				email: {
					required,
					email
				},
				password: {
					required,
					minLength: minLength(8),
					maxLength: maxLength(16)
				}
			}, form);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;
				store.dispatch('auth/login', form).then(setUser).catch(catchError);
			}

			const setUser = () => {
				store.dispatch('auth/me').then(redirectNext).catch(catchError);
			}

			const forgot = () => {
				router.push({ name: 'auth.forgot' });
			}

			return { ...toRefs(form), validation, validationExternal, submitting, submit, forgot };
		}
	}
</script>